import React from 'react'; // eslint-disable-line no-unused-vars
import { Map } from 'immutable';
import { connect } from 'react-redux';
//import * as Session from '../../session'
import { currentUser, getCategories, getDraftItem, getPendingItemIds, getPendingItems } from '../../reducer';

import { addDraftItemImage,clearDraftItemImage,clearDraftItemCategoryId, addDraftItemVenueId, submitSnapForm, addDraftItemVenuePermalink, getItems, addPendingSnap, clearDraftItemName} from '../actions'

import SnapPhotoView from '../components/SnapPhotoView'

import { logOut } from '../../session/actions'

const mapStateToProps = (state) => {

  let account_subdomain = '';
  const account = currentUser(state).get("account");
  if (account !== undefined){
    account_subdomain = account.subdomain;
  }

  const venue_id = getDraftItem(state).get("venue_id");
  let venue = currentUser(state).get("venues").find((v) => v.id === venue_id);
  if (!venue) {
      venue = currentUser(state).get("venues")[0];
  }

  let category_name = '';
  let category_id = getDraftItem(state).get("category_id");
  const categories = (new Map(venue.categories.map(c => c.category).reduce(
      ((obj, v, n) => (obj[n.toString()] = v, obj)), {})
  )).map(c => new Map(c));

  if (category_id && categories.get(category_id.toString())) {
    category_name = categories.get(category_id.toString()).get("name")
  } else {
      category_id = '';
  }
  return {
    pending_item_ids: getPendingItemIds(state),
    pending_items: getPendingItems(state),
    current_user_id: currentUser(state).get("id"),
    current_user: currentUser(state),
    venues: currentUser(state).get("venues"),
    initialValues: {
      venue_id: getDraftItem(state).get("venue_id"),
      name: getDraftItem(state).get("name")
    },
    categories: categories,
    category_name: category_name,
    draft_item: getDraftItem(state),
    apiVars: {
      venue_id: getDraftItem(state).get("venue_id"),
      category_id: getDraftItem(state).get("category_id"),
      image: getDraftItem(state).get("image"),
      api_token: currentUser(state).get("api_token"),
      venue_permalink: getDraftItem(state).get("venue_permalink"),
      account_subdomain: account_subdomain
    }
  }
};


function s4() {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
}

const mapDipatchToProps = (dispatch, ownProps) => {
  return {
    handleVenueChange: (e,venues,{api_token,venue_permalink,account_subdomain}) => {
      dispatch(addDraftItemVenueId(e.target.value));
      const venue = venues.filter(function( obj ) {
        return obj.id.toString() === e.target.value;
      });
      dispatch(addDraftItemVenuePermalink(venue[0].permalink));
      dispatch(getItems(api_token,venue[0].permalink,account_subdomain));
    },
    handleTitleBackClick: (e) => {
      dispatch(clearDraftItemCategoryId());
      e.preventDefault();
    },
    handleLogoutClick: () => {
      dispatch(logOut());
    },
    handleClearNameClick: () => {
      dispatch(clearDraftItemName())
      dispatch({
        type: "@@redux-form/CHANGE",
        meta: {
          form: "snap-photo",
          field: "name",
          touch: false,
          persistentSubmitErrors: false,
        },
        payload: ""
      });
    },
    onSubmit: ({name,description,internal_notes},{category_id,venue_id,image,api_token,venue_permalink,account_subdomain}) => {

      const pending_id = s4() + s4();

      dispatch(submitSnapForm(name,description,internal_notes,category_id,venue_id,image,api_token,venue_permalink,account_subdomain,pending_id));

      dispatch(addPendingSnap({name,description,internal_notes,category_id,venue_id,image,api_token,venue_permalink,account_subdomain,pending_id}));

    },
    addScreenShot: (image) => {
      dispatch(addDraftItemImage(image));
    },
    clearDraftItemImage: () => {
      dispatch(clearDraftItemImage());
    }
  }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    onSubmit: (formData) => dispatchProps.onSubmit(formData,stateProps.apiVars),
    handleVenueChange: (e) => dispatchProps.handleVenueChange(e,stateProps.venues,stateProps.apiVars)
  })
}

export const SnapPhoto = connect(mapStateToProps,mapDipatchToProps,mergeProps)(SnapPhotoView);

export default SnapPhoto;



// WEBPACK FOOTER //
// ./src/snapit_app/containers/SnapPhoto.js